import { createAction, props } from '@ngrx/store';
import { Pagination } from '../../models/pagination.model';

export const addToStore = createAction(
  '[Pagination] Load Pagination to store',
  props<{ pagination: Pagination }>()
);

export const getPagination = createAction(
  '[Pagination] Get pagination',
  props<{ id: string }>()
);

export const updateAction = createAction(
  '[Pagination] Update',
  props<{ pagination: Pagination }>()
);
export const updateFailure = createAction(
  '[Pagination] Update Failure',
  props<{ error: any }>()
);
export const updateSuccess = createAction(
  '[Pagination] Update Success',
  props<{ pagination: Pagination }>()
);

// Delete Pagination Actions
export const deleteAction = createAction(
  '[Pagination] Delete',
  props<{ id: string }>()
);
export const deleteFailure = createAction(
  '[Pagination] Delete failure',
  props<{ error: any }>()
);
export const deleteSuccess = createAction(
  '[Pagination] Delete success',
  props<{ id: string }>()
);

export const clearFromStore = createAction(
  '[Pagination] Clear from store',
  props<{ id: string }>()
);

export const clear = createAction('[Pagination] Clear Paginations');
